/**
 * Customer Use Case - FAQ Accordion
 */
(function() {
  'use strict';

  function initUseCaseFAQ() {
    var items = document.querySelectorAll('.use-case-faq__item');

    items.forEach(function(item) {
      var question = item.querySelector('.use-case-faq__question');
      if (!question) return;

      question.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');

        // Close all items in same FAQ group
        var parent = item.closest('.use-case-faq__list');
        if (parent) {
          parent.querySelectorAll('.use-case-faq__item.is-open').forEach(function(openItem) {
            openItem.classList.remove('is-open');
          });
        }

        // Toggle current
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUseCaseFAQ);
  } else {
    initUseCaseFAQ();
  }
})();
